<template>
  <!-- 国家及地区英文 -->

  <a-form
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    class="mb20 pr20 pl20"
  >
    <a-row>
      <a-col
        :span="24"
        class="tar"
        style="display:flex;justify-content:space-between;"
      >
        <a @click="back"> <LeftOutlined class="fs20"/></a>
        <div class="btns">
          <!-- <a-button type="primary" ghost @click="show(0)" class="mr10"
            >数据导出</a-button
          >
          <a-button type="primary" class="mr10">批量导入</a-button> -->
          <a-button type="primary" @click="show(0)">创建菜单</a-button>
        </div>
      </a-col>
    </a-row>
  </a-form>
  <EventAlert v-if="visible" />
</template>
<script>
import { LeftOutlined } from '@ant-design/icons-vue'
import { inject, reactive, toRefs } from 'vue'
import EventAlert from './EventAlert.vue'
export default {
  components: {
    LeftOutlined,
    EventAlert
  },
  setup() {
    const menusState = inject('menusState')
    const state = inject('state')

    const searchState = reactive({
      ok() {
        const { setAttrs, setEmpty } = menusState
        setAttrs('visible', true)
        setEmpty()
      },
      back() {
        state.type = ''
      }
    })
    return {
      labelCol: { span: 10 },
      wrapperCol: { span: 14 },
      ...toRefs(searchState),
      ...toRefs(menusState)
    }
  }
}
</script>
